const data = {
    product: [
      {id:1, 
      title:"Trendyol Collection Blouse - 4297 - Fitted", 
      img:'Women/2_org_zoom.jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Polyester'},
        {Fabric_Type:'Knitwear'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Acrylic'},
        {Fit:'Regular'}
      ],
      count:15,
      price:13.99,
      color:[
        "#3b5490", "#f44c4c", "gray"
      ],
      parentCat:"women",
      childCat:"Blouses",
      top10:false,
      like:18,
      liked:false
    },
    {id:2, 
      title:"Trendyol Collection Shirt - 3654 - Oversize", 
      img:'Women/5_org_zoom.jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton & polyester'},
        {Fabric_Type:'Woven'},
        {Lapel:'Shirt collar'},
        {Fabric___Yarn:'Cotton & Polyester'},
        {Fit:'Regular'}
      ],
      count:12,
      price:17.99,
      color:[
        "#f44c4c", "gray", "#3b5490"
      ],
      parentCat:"women",
      childCat:"Shirts",
      top10:false,
      like:12,
      liked:false
    },
    {id:3, 
      title:"Trend Alaçatı Stili Shirt - 7236 - Regular", 
      img:'Women/1_org_zoom%20(1).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Woven'},
        {Lapel:'Standing collar'},
        {Fabric___Yarn:'-------'},
        {Fit:'Regular'}
      ],
      count:18,
      price:16.99,
      color:[
        "#3b5490", "gray", "#f44c4c"
      ],
      parentCat:"women",
      childCat:"Shirts",
      top10:false,
      like:29,
      liked:false
    },
    {id:4, 
      title:"Trend Alaçatı Stili Shirt - 1924 - Regular", 
      img:'Women/vsvsvdsvwr.jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Woven'},
        {Lapel:'Lapel collar'},
        {Fabric___Yarn:'-------'},
        {Fit:'Regular'}
      ],
      count:8,
      price:19.99,
      color:[
        "#374151", "#3b5490", "#f44c4c"
      ],
      parentCat:"women",
      childCat:"Shirts",
      top10:false,
      like:35,
      liked:false
    },
    {id:5, 
      title:"Armonika Jacket - 3261 - Regular", 
      img:'Women/2_org_zoom%20(2).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton & polyester'},
        {Fabric_Type:'Woven'},
        {Lapel:'Lapel collar'},
        {Fabric___Yarn:'-------'},
        {Fit:'Regular'}
      ],
      count:20,
      price:16.99,
      color:[
        "#3b5490", "#374151", "gray"
      ],
      parentCat:"women",
      childCat:"Blazers",
      top10:false,
      like:42,
      liked:false
    },
    {id:6, 
      title:"Trend Alaçatı Stili Jacket - 9644 - Oversize", 
      img:'Women/3_org_zoom.jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Woven'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'-------'},
        {Fit:'Oversize'}
      ],
      count:14,
      price:30.99,
      color:[
        "#3b5490", "#f44c4c", "gray"
      ],
      parentCat:"women",
      childCat:"Blazers",
      top10:false,
      like:40,
      liked:false
    },
    {id:7, 
      title:"Trendyol Collection Jeans - 9784 - Mom", 
      img:'Women/2_org_zoom (4).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Denim'},
        {Lapel:'-------'},
        {Fabric___Yarn:'Rigid'},
        {Fit:'Mom'}
      ],
      count:19,
      price:19.99,
      color:[
        "#ebe1d5", "#374151", "gray"
      ],
      parentCat:"women",
      childCat:"Jean",
      top10:false,
      like:34,
      liked:false
    },
    {id:8, 
      title:"Trendyol Collection Jeans - 9362 - Skinny", 
      img:'Women/2_org_zoom (5).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton mix'},
        {Fabric_Type:'Denim'},
        {Lapel:'-------'},
        {Fabric___Yarn:'Stretch'},
        {Fit:'Skinny'}
      ],
      count:15,
      price:24.99,
      color:[
        "#3b5490", "#f44c4c", "gray"
      ],
      parentCat:"women",
      childCat:"Jean",
      top10:false,
      like:38,
      liked:false
    },
    {id:9, 
      title:"Trendyol Collection Jacket - 6648 - Blazers", 
      img:'Women/1_org_zoom (3).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton mix'},
        {Fabric_Type:'Denim'},
        {Lapel:'Lapel collar'},
        {Fabric___Yarn:'Fake Linen'},
        {Fit:'Blazers'}
      ],
      count:10,
      price:29.99,
      color:[
        "#3b5490", "#83b0d9", "gray"
      ],
      parentCat:"women",
      childCat:"Blazers",
      top10:false,
      like:57,
      liked:false
    },
    {id:10, 
      title:"Trend Alaçatı Stili Shirt - 7231 - Regular", 
      img:'Women/1_org_zoom (2).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Woven'},
        {Lapel:'Standing collar'},
        {Fabric___Yarn:'-------'},
        {Fit:'Regular'}
      ],
      count:23,
      price:19.99,
      color:[
        "#3b5490", "gray", "#f44c4c"
      ],
      parentCat:"women",
      childCat:"Shirts",
      top10:false,
      like:46,
      liked:false
    },
    {id:11, 
      title:"Trendyol Collection Shirt - 3627 - Oversize", 
      img:'Women/2_org_zoom (3).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton & polyester'},
        {Fabric_Type:'Woven'},
        {Lapel:'Shirt collar'},
        {Fabric___Yarn:'Cotton & Polyester'},
        {Fit:'Regular'}
      ],
      count:17,
      price:20.99,
      color:[
        "gray", "#3b5490", "#83b0d9"
      ],
      parentCat:"women",
      childCat:"Shirts",
      top10:false,
      like:31,
      liked:false
    },
    {id:12, 
      title:"Trendyol Collection Jacket - 9342 - Blazers", 
      img:'Women/3_org_zoom (1).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton & polyester'},
        {Fabric_Type:'Woven'},
        {Lapel:'Lapel collar'},
        {Fabric___Yarn:'Aerobin'},
        {Fit:'Blazers'}
      ],
      count:5,
      price:29.99,
      color:[
        "#3b5490", "#bf7f73", "#374151"
      ],
      parentCat:"women",
      childCat:"Shirts",
      top10:false,
      like:50,
      liked:false
    },
    {id:13, 
      title:"DYNAMO Jacket - 9647 - Puffer", 
      img:'Men/1_org_zoom (3).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Polyester'},
        {Fabric_Type:'Woven'},
        {Lapel:'Hood'},
        {Fabric___Yarn:'Polar'},
        {Fit:'Regular'}
      ],
      count:17,
      price:45.99,
      color:[
        "#3b5490", "#374151", "gray"
      ],
      parentCat:"men",
      childCat:"Jackets",
      top10:false,
      like:28,
      liked:false
    },
    {id:14, 
      title:"Avva Jeans - 7931 - Slim", 
      img:'Men/3_org_zoom (4).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton mix'},
        {Fabric_Type:'Woven'},
        {Lapel:'Hood'},
        {Fabric___Yarn:'Polar'},
        {Fit:'Slim Fit'}
      ],
      count:25,
      price:46.99,
      color:[
        "#bf7f73", "#3b5490", "gray"
      ],
      parentCat:"men",
      childCat:"Blazers",
      top10:false,
      like:32,
      liked:false
    },
    {id:15, 
      title:"Dagi T-Shirt - 5423", 
      img:'Men/2_org_zoom (3).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton & polyester'},
        {Fabric_Type:'Knitwear'},
        {Lapel:'High neck'},
        {Fabric___Yarn:'Cotton & Polyester'},
        {Fit:'Fitted'}
      ],
      count:10,
      price:10.99,
      color:[
        "black", "#374151", "gray"
      ],
      parentCat:"men",
      childCat:"T-Shirts",
      top10:false,
      like:42,
      liked:false
    },
    {id:16, 
      title:"Trendyol Collection Sweatshirt - 6423 - Regular", 
      img:'Men/3_org_zoom.jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton mix'},
        {Fabric_Type:'Knit'},
        {Lapel:'Hood'},
        {Fabric___Yarn:'2 Ply'},
        {Fit:'Regular'}
      ],
      count:12,
      price:24.99,
      color:[
        "#bf7f73", "#3b5490", "gray"
      ],
      parentCat:"men",
      childCat:"Sweatshirts",
      top10:false,
      like:19,
      liked:false
    },
    {id:17, 
      title:"Trendyol Collection T-Shirt - 97523 - Regular", 
      img:'Men/6_org_zoom.jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton & polyester'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'2 Ply'},
        {Fit:'Regular'}
      ],
      count:16,
      price:9.99,
      color:[
        "#3b5490", "#f44c4c", "gray"
      ],
      parentCat:"men",
      childCat:"T-Shirts",
      top10:false,
      like:24,
      liked:false
    },
    {id:18, 
      title:"DYNAMO Vest - 7741 - Fitted", 
      img:'Men/2_org_zoom (2).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Polyester'},
        {Fabric_Type:'Woven'},
        {Lapel:'Hood'},
        {Fabric___Yarn:'Polar'},
        {Fit:'Fitted'}
      ],
      count:8,
      price:35.99,
      color:[
        "#374151", "#646758", "gray"
      ],
      parentCat:"men",
      childCat:"Sweatshirts",
      top10:false,
      like:30,
      liked:false
    },
    {id:19, 
      title:"Trendyol Collection Sweater - 9350 - Fitted", 
      img:'Men/1_org_zoom (5).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton-Polyester'},
        {Fabric_Type:'Knitwear'},
        {Lapel:'High neck'},
        {Fabric___Yarn:'Cotton & Polyester'},
        {Fit:'Regular'}
      ],
      count:19,
      price:11.99,
      color:[
        "gray", "#374151", "#3b5490"
      ],
      parentCat:"men",
      childCat:"Sweatshirts",
      top10:false,
      like:16,
      liked:false
    },
    {id:20, 
      title:"Sateen Men T-Shirt - 1496 - Standard", 
      img:'Men/2_org_zoom.jpeg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton'},
        {Fabric_Type:'Knitwear'},
        {Lapel:'High neck'},
        {Fabric___Yarn:'Cotton & Polyester'},
        {Fit:'Standard'}
      ],
      count:5,
      price:7.99,
      color:[
        "#3b5490", "#bf7f73", "gray"
      ],
      parentCat:"men",
      childCat:"T-Shirts",
      top10:false,
      like:29,
      liked:false
    },
    {id:21, 
      title:"DYNAMO Jacket - 9642 - Slim Fit", 
      img:'Men/2_org_zoom (5).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton & polyester'},
        {Fabric_Type:'Knit'},
        {Lapel:'Hood'},
        {Fabric___Yarn:'Cotton & Polyester'},
        {Fit:'Slim Fit'}
      ],
      count:20,
      price:24.99,
      color:[
        "#374151", "#3b5490", "gray"
      ],
      parentCat:"men",
      childCat:"Blazers",
      top10:false,
      like:35,
      liked:false
    },
    {id:22, 
      title:"Trendyol Collection Shorts & Bermudas - 6594 - Normal Waist", 
      img:'Men/2_org_zoom (6).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'polyester'},
        {Fabric_Type:'Knit'},
        {Lapel:'Hood'},
        {Fabric___Yarn:'2 Ply'},
        {Fit:'Regular'}
      ],
      count:15,
      price:15.99,
      color:[
        "#3b5490", "#83b0d9", "#f44c4c"
      ],
      parentCat:"men",
      childCat:"T-Shirts",
      top10:false,
      like:26,
      liked:false
    },
    {id:23, 
      title:"Trendyol Collection Shirt - 6049 - Slim", 
      img:'Men/1_org_zoom (1).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton & polyester'},
        {Fabric_Type:'Knitwear'},
        {Lapel:'High neck'},
        {Fabric___Yarn:'Cotton & Polyester'},
        {Fit:'Fitted'}
      ],
      count:12,
      price:18.99,
      color:[
        "gray", "#83b0d9", "black"
      ],
      parentCat:"men",
      childCat:"Shirts",
      top10:false,
      like:41,
      liked:false
    },
    {id:24, 
      title:"Trendyol Collection T-Shirt - 3084 - Regular", 
      img:'Men/2_org_zoom (7).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:17,
      price:15.99,
      color:[
        "#3b5490", "#374151", "gray"
      ],
      parentCat:"men",
      childCat:"T-Shirts",
      top10:false,
      like:32,
      liked:false
    },
    {id:25, 
      title:"POLO HENLEY PULLOVER - 5454", 
      img:'Women/01.webp', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:20,
      price:85.99,
      color:[
        "gray", "#3b5490", "#83b0d9"
      ],
      parentCat:"women",
      childCat:"Top 10",
      top10:true,
      like:43,
      liked:false
    },
    {id:26, 
      title:"QUILTED CROPPED ARENA HOODIE - 7462", 
      img:'Women/03.webp', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:15,
      price:67.99,
      color:[
        "black", "gray"
      ],
      parentCat:"women",
      childCat:"Top 10",
      top10:true,
      like:39,
      liked:false
    },
    {id:27, 
      title:"RIBBED AMELIA SHRUG - 8613", 
      img:'Women/02.webp', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:12,
      price:84.99,
      color:[
        "gray", "#83b0d9", "#f44c4c"
      ],
      parentCat:"women",
      childCat:"Top 10",
      top10:true,
      like:52,
      liked:false
    },
    
    {id:28, 
      title:"DEVOTION CREW NECK PULLOVER - 9650", 
      img:'Women/04.webp', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:10,
      price:61.99,
      color:[
        "black", "gray"
      ],
      parentCat:"women",
      childCat:"Top 10",
      top10:true,
      like:50,
      liked:false
    },
    {id:29, 
      title:"POLO HENLEY PULLOVER - 2671", 
      img:'Women/05.webp', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:15,
      price:75.99,
      color:[
        "#83b0d9", "gray", "#f44c4c"
      ],
      parentCat:"women",
      childCat:"Top 10",
      top10:true,
      like:44,
      liked:false
    },
    {id:30, 
      title:"ALOSOFT FINESSE TEE - 6470", 
      img:'Women/06.webp', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:18,
      price:82.99,
      color:[
        "black", "gray"
      ],
      parentCat:"women",
      childCat:"Top 10",
      top10:true,
      like:46,
      liked:false
    },
    {id:31, 
      title:"AIRBRUSH HOT SHOT BODYSUIT - 8607", 
      img:'Women/07.webp', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:11,
      price:88.99,
      color:[
        "gray", "black", "#374151"
      ],
      parentCat:"women",
      childCat:"Top 10",
      top10:true,
      like:59,
      liked:false
    },
    {id:32, 
      title:"BANDANA SCARF - 8681", 
      img:'Women/08.webp', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:8,
      price:72.99,
      color:[
        "#374151", "black"
      ],
      parentCat:"women",
      childCat:"Top 10",
      top10:true,
      like:53,
      liked:false
    },
    {id:34, 
      title:"Superlife Shorts & Bermudas - 9674 - Bootcut & Fla#3b5490", 
      img:'Men/4_org_zoom.jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Woven'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'2 Ply'},
        {Fit:'Regular'}
      ],
      count:16,
      price:82.99,
      color:[
        "black", "gray"
      ],
      parentCat:"men",
      childCat:"Top 10",
      top10:true,
      like:42,
      liked:false
    },
    
    {id:35, 
      title:"Superlife Shorts & Bermudas - 5121 - Bootcut & Fla#3b5490", 
      img:'Men/2_org_zoom (8).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton-Polyester-Elastane'},
        {Fabric_Type:'Woven'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'2 Ply'},
        {Fit:'Regular'}
      ],
      count:12,
      price:64.99,
      color:[
        "#ebe1d5", "gray"
      ],
      parentCat:"men",
      childCat:"Top 10",
      top10:true,
      like:46,
      liked:false
    },
    {id:33, 
      title:"Trendyol Collection Shorts & Bermudas - 9671", 
      img:'Men/4_org_zoom (1).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:10,
      price:98.99,
      color:[
        "#374151", "black", "gray"
      ],
      parentCat:"men",
      childCat:"Top 10",
      top10:true,
      like:48,
      liked:false
    },
    {id:36, 
      title:"Superlife T-Shirt - 7592 - Straight", 
      img:'Men/2_org_zoom (9).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:25,
      price:62.99,
      color:[
        "black", "gray"
      ],
      parentCat:"men",
      childCat:"Top 10",
      top10:true,
      like:51,
      liked:false
    },
    
    {id:37, 
      title:"TRIUMPH CREW NECK SWEATSHIRT - 7834", 
      img:'Men/1_org_zoom (4).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton-Polyester-Elastane'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'2 Ply'},
        {Fit:'Regular'}
      ],
      count:7,
      price:78.99,
      color:[
        "gray", "#83b0d9", "black"
      ],
      parentCat:"men",
      childCat:"Top 10",
      top10:true,
      like:39,
      liked:false
    },
    {id:38, 
      title:"Trendyol Collection Shorts & Bermudas - 6441", 
      img:'Men/3_org_zoom (1).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton-Polyester-Elastane'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'2 Ply'},
        {Fit:'Regular'}
      ],
      count:18,
      price:91.99,
      color:[
        "#ebe1d5", "gray"
      ],
      parentCat:"men",
      childCat:"Top 10",
      top10:true,
      like:53,
      liked:false
    },
    {id:39, 
      title:"LEGEND JACKET - 7962", 
      img:'Men/02.webp', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'100% cotton'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'Jersey'},
        {Fit:'Regular'}
      ],
      count:10,
      price:96.99,
      color:[
        "#bf7f73", "#3b5490", "#f44c4c"
      ],
      parentCat:"men",
      childCat:"Top 10",
      top10:true,
      like:41,
      liked:false
    },
    {id:40, 
      title:"Superlife T-Shirt - 7530", 
      img:'Men/3_org_zoom (2).jpg', 
      body:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nesciunt, nam expedita culpa earum ipsa aliquam ipsum at iste dignissimos et autem placeat, ipsam commodi velit, sapiente magni? Deserunt, ducimus. Quibusdam! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Aut, ratione dicta. Ea debitis sequi quos earum blanditiis dicta laborum, tenetur quasi excepturi, ipsa vero voluptatum optio reprehenderit saepe placeat. Sapiente. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maxime earum voluptas similique commodi illo ipsam nihil, sunt quis ex accusamus maiores voluptatum nostrum sequi architecto culpa itaque dolor reprehenderit assumenda.', 
      detail:[
        {Material:'Cotton-Polyester-Elastane'},
        {Fabric_Type:'Knit'},
        {Lapel:'Crew neck'},
        {Fabric___Yarn:'2 Ply'},
        {Fit:'Regular'}
      ],
      count:22,
      price:91.99,
      color:[
        "#3b5490", "gray"
      ],
      parentCat:"men",
      childCat:"Top 10",
      top10:true,
      like:48,
      liked:false
    },
    
    ].reverse(),
    cat:{
      women:[
        "Shirts",
        "Blazers",
        "Jean",
        "Blouses",
        "Top 10"
      ],
      men:[
        "T-Shirts",
        "Sweatshirts",
        "Blazers",
        "Jackets",
        "Top 10"
      ]
    }
  };  

export default data;